module.exports = "/_next/static/images/2173f53747a1edbfc7c4995a3dcdd241-LogoPaypal.jpg.webp";